import { BodyText, HeadingText, Page } from '@cint/wonderment';

export const ResourceNotFound = () => {
  return (
    <Page>
      <div className="flex flex-col items-center justify-center min-h-[400px] gap-4 text-center">
        <HeadingText variant="h3">
          Oops! This resource doesn&apos;t exist.
        </HeadingText>
        <BodyText className="ds-text-secondary">
          Check the URL or go back home.
        </BodyText>
      </div>
    </Page>
  );
};
